/*
 * Credit card top up account response.
 */
export interface ITopUpAccountResponse {
    /**
     * Description
     */
    readonly description?: string;
    /**
     * The member's new Trade Me account balance after topping up their account.
     */
    readonly newAccountBalance?: number;
    /**
     * Success
     */
    readonly success: boolean;
}
